import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { API_STATUS, ApiResponse, ERROR_RESPONSE, STATUS_CODE_MSG } from "../model/api.model";

export function httpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const formatErrorMsg = (error:HttpErrorResponse)=>{
        const response:ApiResponse = {
            result:[],
            status:API_STATUS['Error'],
            errorMsg:''
        }
        const statusCodes:any = STATUS_CODE_MSG;
        const errorCode:any = error?.status.toString();
        if(error?.error.message){
            response['errorMsg'] = error.error.message;
        }else if(Object.keys(statusCodes).includes(errorCode)){
            response['errorMsg'] = statusCodes[errorCode];
        }else{
            response['errorMsg'] = statusCodes['default'];
        }
    return response
    }
    if(sessionStorage.getItem('token') !== '' && sessionStorage.getItem('token') !== 'undefined' && sessionStorage.getItem('id_token') !== 'undefined' && sessionStorage.getItem('id_token') !== ''&& sessionStorage.getItem('Refresh_token') !== 'undefined' && sessionStorage.getItem('Refresh_token') !== '') {
        return next(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const formattedResponse = formatErrorMsg(error)
    
                return throwError(() => formattedResponse);
            })
        );
    }else{
        const response:ApiResponse = {
            result:[],
            status:API_STATUS['Error'],
            errorMsg:''
        }
       const confirmed = globalThis.confirm(ERROR_RESPONSE['tokenExpired']);
          if (confirmed) {
            sessionStorage.clear();
            globalThis.location.reload();
           } 
       return throwError(() => response);
    }
  }

